/**
 * @file index.tsx
 * @module app/modules/sales-management/index
 * @description Implements the index interface for sales-management operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { lazy } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import SalesManagerIndex from './sales-manager';
import SalesRepresentativeIndex from './sales-representative';
import SalesManagementAdminIndex from './admin';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const salesManagementBreadCrumbs: Array<PageLink> = [
    {
        title: 'Sales Management',
        path: '/sales-management',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];
const SalesManagementIndex = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path="admin/*"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementBreadCrumbs}>
                  Admin
                </PageTitle>
                <SalesManagementAdminIndex />
              </>
            }
          />
          <Route
            path="manager/*"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementBreadCrumbs}>
                  Sales Manager
                </PageTitle>
                <SalesManagerIndex />
              </>
            }
          />
          <Route
            path="representative/*"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementBreadCrumbs}>
                  Sales Representative
                </PageTitle>
                <SalesRepresentativeIndex />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default SalesManagementIndex;
